import React from 'react';

// GLOBAL VARIABLES
import { INTERFACE } from 'pathnames.js';

// GLOBAL COMPONENTS
import Title from 'parts/title/Title';
import Feature from 'parts/feature/Feature';

// LOCAL COMPONENTS
import ExcelButtons from 'routers/interface/tools/ExcelButtons.js';

// MAIN COMPONENT
const Tools = ({
  fileName
}) => {

  // RENDER
  return (<>
    <ExcelButtons fileName={fileName} />
    <Feature roles={['dslAdmin', 'inventoryManager', 'salesManager', 'salesManagerPlus']}>
      <Title.AddNewUsed
        pathname={INTERFACE.inventory}
      />
    </Feature>
  </>)
}

export default Tools